import React, { Component } from 'react';
import { renderToString } from 'react-dom/server';
import { SwaggerSpec } from '../../../classes';

import './ApiDocumentationIframe.css';

const SvgAir = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 276.542 122.542" ref={svgRef} {...{ ...{ width: '1em', height: '1em' }, ...props }}>
    <title>{title}</title>
    <path
      d="M109.02.022c-1.494.053-2.99.195-4.382.324-9.68.9-18.611 4.727-25.907 11.15-14.217 12.511-20.982 31.22-29.85 47.436-6.147.86-11.452 1.525-15.402 2.126-.878.133-1.035.684-1.035.684l-3.084 6.935-.046.096-3 6.726s-.258.7.336.66c2.44-.156 6.766-.708 15.475-1.92l1.66-.229c-1.003.138-10.554 21.754-13.89 25.426-5.08 5.595-11.958 8.99-19.486 9.615-2.617.217-8.635-2.813-10.047-.76-.957 1.39.25 7.247.698 8.834 1.115 3.947 3.744 4.19 7.447 4.37 6.669.323 13.313-1.007 18.967-4.66C38.035 110.01 43.26 97.508 48.548 86.64c2.395-4.92 4.827-9.86 7.894-14.402 5.72-.806 11.841-1.672 17.975-2.55l5.699-.81c-.756.107-3.104 11.983-3.416 13.226-1.3 5.17-2.483 10.4-3.046 15.708-.5 4.733-.59 9.656.664 14.284.94 3.48 2.742 8.758 6.554 9.902 4.607 1.381 11.962-.826 16.303-2.454 4.443-1.668 24.059-13.67 24.025-14.394.167 3.674.56 7.458 1.733 10.963 1.623 4.86 3.224 6.3 8.37 5.916 9.106-.68 17.787-5.125 24.74-10.87 25.159-20.803 35.556-43.943 40.85-45.658 22.635 11.223-16.47 45.517 4.807 56.467 3.398 1.751 15.585-.928 21.628-2.4 10.705-2.607 21.325-5.744 31.495-10.01 5.07-2.126 10.196-4.182 15-6.882 6.502-3.65 8.474-4 5.089-11.474-.717-1.584.578-5.877.08-7.68-14.827 11.427-61.705 31.708-65.204 24.15-1.378-2.97 1.75-9.3 2.642-12.13 2.52-8.013 6.734-16.631 4.89-25.235-1.976-9.21-9.836-10.601-18.022-15.62.816-4.391 1.677-8.737 1.203-14.417-2.78-2.53-9.655-3.952-12.745-1.294-5.03 4.326-1.714 15.246-.474 20.517-5.487 11.04-32.044 45.278-51.66 49.26-4.347-21.79 7.686-52.244 8.405-57.67h-12.013c-3.98 12.043-9.854 38.955-10.218 39.333-1.559 1.618-5.643 4.468-6.459 5.245-2.366 2.243-16.475 12.549-21.872 13.662-6.642 1.37-6.777-5.01-6.886-10.482-.221-11.17 4.107-21.963 8.36-32.087 5.873-.845 11.2-1.682 15.513-2.237 1.05-.136 1.332-.958 1.332-.958l2.897-6.497.053-.115s.115-.255.13-.27l2.97-6.703s.37-.976-.6-.817c-5.485.888-11.41 1.654-17.474 2.527 1.065-.154 8.784-22.632 9.878-25.17 2.807-6.5 5.187-13.193 6.795-20.093 1.13-4.852 1.71-5.387-3.042-6.184-1.387-.233-2.877-.267-4.371-.214zm-7.043 10.207c.003 7.458-4.95 14.924-8.413 22.83-3.04 6.95-6.026 13.95-8.768 20.773-7.968 1.141-15.845 2.267-23.155 3.302 8.962-20.117 17.29-40.872 40.336-46.905zm46.794 3.473c-4.914-.023-8.343 4.388-9.508 7.898-.81 2.44-2.733 5.79-1.023 8.26 2.726 3.946 9.711 3.399 12.89.577 3.661-3.247 7.32-12.4 3.023-15.036-1.94-1.191-3.744-1.691-5.382-1.699z"
      fill="currentColor"
    />
  </svg>
);

const brandStyle = { margin: 10, width: 80, height: 40 };

const branding = (
  <div className="SwaggerBranding" style={{ color: '#ffffff', backgroundColor: '#2bb5ae', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
    <SvgAir style={{ ...brandStyle }} />
    <div style={{ margin: 10 }}>MyFleet</div>
  </div>
);

class ApiDocumentationIframe extends Component {
  constructor(props) {
    super(props);
    const swaggerSpecClass = new SwaggerSpec();
    this.spec = swaggerSpecClass.spec;
  }

  componentDidMount = () => {
    const page = `<!DOCTYPE html>
      <html xmlns="http://www.w3.org/1999/xhtml">
      <head>
        <meta charset="UTF-8">
        <title>Swagger</title>
        <link rel="stylesheet" type="text/css" href="https://unpkg.com/swagger-ui-dist@3.25.0/swagger-ui.css">
      </head>
      <body style="margin:0px">
      <div id="swagger-ui"></div>
      <script src="https://unpkg.com/swagger-ui-dist@3.25.0/swagger-ui-standalone-preset.js"></script>
      <script src="https://unpkg.com/swagger-ui-dist@3.25.0/swagger-ui-bundle.js"></script>
      <script src="https://unpkg.com/react@16/umd/react.production.min.js"></script>
      <script src="https://unpkg.com/html-react-parser@latest/dist/html-react-parser.min.js"></script>
      <script>
        window.onload = function() {
          const HideInfoUrlPartsPlugin = () => {
            return {
              wrapComponents: {
                SvgAssets: (Original, { React }) => (props) => {
                  return React.createElement("div", null,
                    window.HTMLReactParser(branding),
                    React.createElement(Original, props)
                  )
                },
                InfoUrl: () => () => null
              }
            }
          }
          
          const ui = SwaggerUIBundle({
            spec,
            dom_id: '#swagger-ui',
            requestInterceptor: (req) => {
              if (req.headers.hasOwnProperty('Authorization') && !req.headers.Authorization.startsWith('Bearer ')) {
                req.headers.Authorization = \`Bearer \${req.headers.Authorization}\`;
              }  
              return req;
            },
            deepLinking: true,
            presets: [
                SwaggerUIBundle.presets.apis,
                SwaggerUIStandalonePreset
            ],
            plugins: [
                SwaggerUIBundle.plugins.DownloadUrl,
                HideInfoUrlPartsPlugin
            ],
            layout: "BaseLayout"
          })
          window.ui = ui
        }
      </script>
      </body>
      </html>`;
    const frame = this.refs.frame;
    const ifrmDoc = frame.contentWindow.document;
    frame.contentWindow.spec = this.spec;
    frame.contentWindow.branding = renderToString(branding);
    ifrmDoc.open();
    ifrmDoc.write(page);
    ifrmDoc.close();
  };

  shouldComponentUpdate = () => {
    return false;
  };

  render = () => {
    return <iframe className="ApiDocumentationIframe" title="ApiDocumentationIframe" id="frame" ref="frame" />;
  };
}

export default ApiDocumentationIframe;



// WEBPACK FOOTER //
// ./src/components/ApiDocumentation/ApiDocumentationIframe/ApiDocumentationIframe.js